import {Component, Input, OnInit} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 're-configuration-delete-confirmation-dialog',
    templateUrl: './parameters-delete-confirmation-dialog.component.html',
    styleUrls: ['./parameters-delete-confirmation-dialog.component.scss'],
    standalone: false
})
export class ParametersDeleteConfirmationDialogComponent implements OnInit {
  //@Input("deleteCount") deleteCount: number;

  constructor(private activeModal: NgbActiveModal, private router: Router) { }
  deleteCount: { deleteCount: number };
  ngOnInit(): void {
    console.log(this.deleteCount.deleteCount);
  }


  deleteParameter() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }

}
